export enum AreaTypeEnum {

    Polygon = 1,
    Circle = 2,
    Line = 3
}
